<template>
    <div>

        <div v-if="showTranscript" @click.self="showTranscript = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
            <div class="w-full sm:w-2/3 lg:w-2/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                <div class="p-6" style="position: relative; height: calc(100% - 40px); overflow: auto;">

                <div class="float-right -mb-4" style="position: relative;">
                    <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                </div>

                <div style="clear: both; padding-top: 10px;"></div>

                <div>
                    <div v-if="loading_bland_recording" :class="'w-full mb-3'">
                        <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                    </div>
                    <div class="flex flex-row flex-wrap" v-else>
                        <div class="w-full mb-4">
                            <!-- <iframe :src="bland_recording_data.recording_url" style="width: 100%; height: 500px; border: 0px;"></iframe> -->
                            <div id="bl-audio-el-here"></div>
                        </div>

                        <div style="float: right;">
                            <a href="javascript: void(0);" @click="showFeedbackBox = true;" style="font-size: 12px !important;">Add Feedback</a>
                        </div>
                        
                        <div class="w-full">
                            <hr />
                            
                            <div id="ai-dialog-messages-list"  style="max-height: 500px; overflow: auto;">

                            <div v-if="!bland_recording_data.transcription" class="text-sm" style="text-align: center;">
                                <br />
                                No transcription available.
                            </div>
                            <div v-else>
                                <div>
                                    <div v-if="!bland_recording_data.transcription.messages">
                                        <div class="flex flex-row flex-wrap w-full">
                                            <div :class="'w-full lg:w-1/2'">
                                                <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Transcription</div>

                                                <br />
                                                <div>
                                                    <b-list-group>
                                                        <b-list-group-item
                                                            v-for="(item, index) in bland_recording_data.transcription" :key="index"
                                                    
                                                                class="d-flex align-items-center mb-4 pb-4"
                                                                style="border: none; border-bottom: solid 1px #ededed;"
                                                                v-if="index !== 'messages'"
                                                        >
                                                            <b-avatar v-if="item.speaker == 'A'"
                                                                    text="S1"
                                                                    class="mr-3 call-info-avatar"
                                                            ></b-avatar>
                                                            <b-avatar v-if="item.speaker == 'B'"
                                                                    text="S2"
                                                                    class="mr-3 call-info-avatar"
                                                            ></b-avatar>
                                                            <div>
                                                                <span v-if="item.speaker == 'A'" class="mr-auto primary-color text-bold">AI</span>
                                                                <span v-else class="mr-auto warning-color text-bold">Caller</span>

                                                                <span class="mr-auto"> . {{ displaySpeakerTimestamp(item.start, bland_recording_data.transcription[0].start) }} . </span>
                                                                <!-- <span v-if="item.sentiment == 'Neutral'" class="mr-auto warning-color text-bold">Neutral</span>
                                                                <span v-if="item.sentiment == 'Positive'" class="mr-auto success-color text-bold">Positive</span>
                                                                <span v-if="item.sentiment == 'Negative'" class="mr-auto danger-color text-bold">Negative</span> -->
                                                                <div class="text-sm">{{ item.text }}</div>
                                                            </div>
                                                        </b-list-group-item>
                                                    </b-list-group>
                                                </div>
                                            </div>
                                            <div :class="'w-full lg:w-1/2 pl-3'">
                                                <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Summary</div>

                                                <div style="font-size: 12px;">{{ bland_recording_data.summary || "No summary found." }}</div>

                                                <!-- <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Sentiment</div>

                                                <div style="font-size: 12px;">{{ bland_recording_data.sentiment || "UNKNOWN" }}</div>

                                                <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Topics Discussed</div>

                                                <div style="font-size: 12px;">{{ bland_recording_data.topics_discussed || "No topics discussed." }}</div>

                                                <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Issues Raised</div>

                                                <div style="font-size: 12px;">{{ bland_recording_data.issues_raised || "No issues raised." }}</div> -->

                                                <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Customer Information</div>

                                                <div style="font-size: 12px;">
                                                    <strong>Customer's name:</strong> {{ bland_recording_data.customer_name || "-" }}
                                                    <br />
                                                    <strong>Customer's email:</strong> {{ bland_recording_data.customer_email || "-" }}
                                                    <br />
                                                    <strong>Customer's phone:</strong> {{ bland_recording_data.ai_provided_phone_number || "-" }}
                                                    <br />
                                                    <strong>Service needed:</strong> {{ bland_recording_data.job_type || "-" }}
                                                    <br /><br />
                                                    <strong>Call ended by:</strong> {{ bland_recording_data.call_ended_by || "-" }}
                                                </div>

                                                <!--<div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Analysis</div>

                                                <div v-if="bland_recording_data.analysis" style="font-size: 12px;">
                                                    <div v-for="(item, index) in bland_recording_data.analysis" :key="'variable-' + index">
                                                        <strong>{{ index }}: </strong> {{ item }} <br />
                                                    </div>
                                                </div>
                                                <div v-else style="font-size: 12px;">No analysis detected.</div>-->

                                                <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Variables</div>

                                                <div v-if="bland_recording_data.variables" style="font-size: 12px;">
                                                    <div v-for="(item, index) in bland_recording_data.variables" :key="'variable-' + index">
                                                        <strong>{{ index }}: </strong> {{ item }} <br />
                                                    </div>
                                                </div>
                                                <div v-else style="font-size: 12px;">No variables.</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <b-list-group>
                                            <b-list-group-item
                                                v-for="(item, index) in bland_recording_data.transcription.messages" :key="index"
                                            
                                                        class="d-flex align-items-center mb-4 pb-4"
                                                        style="border: none; border-bottom: solid 1px #ededed;"
                                                >
                                                    <b-avatar v-if="item.participant_type == 2 || item.sender == 'bot'"
                                                            text="S1"
                                                            class="mr-3 call-info-avatar"
                                                    ></b-avatar>
                                                    <b-avatar v-if="item.participant_type == 3 || item.sender == 'human'"
                                                            text="S2"
                                                            class="mr-3 call-info-avatar"
                                                    ></b-avatar>
                                                    <div>
                                                        <span v-if="item.participant_type == 2 || item.sender == 'bot'" class="mr-auto primary-color text-bold">Advertiser</span>
                                                        <span v-else class="mr-auto warning-color text-bold">Customer</span>

                                                        <span class="mr-auto text-xs text-gray-600"> . {{ displayTimestamp(item.event_time) }} . </span>
                                                        <div class="text-sm" v-html="item.text || item.body"></div>
                                                    </div>
                                                </b-list-group-item>
                                        </b-list-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>

                </div>

            </div>
        </div>
        <div v-if="showFeedbackBox" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
            <div class="w-full bg-white mx-6" style="max-width: 400px; max-height: 100%; border-radius: 10px;">

                <div class="rg-modal-header">
                    <span>Add Feedback</span>
                </div>

                <div class="p-6" style="position: relative;">

                <div class="float-right -mb-4" style="position: relative;">
                    <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                </div>

                <div style="clear: both;"></div>

                <div>

                    <p class="text-xs text-gray-600 pt-2">
                        How did the AI agent handle this conversation? <br />
                        - You can share general feedback or report a problem here:
                    </p>

                    <textarea v-model="item.ai_feedback" style="padding: 10px; width: 100%; height: 200px; border: solid 1px #CCCCCC; border-radius: 5px;"></textarea>

                    <br />

                    <p class="text-xs text-gray-600 pt-2">
                        If something needs immediate attention, mark it as urgent below and our team will prioritize it.
                    </p>

                    <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="item.ai_feedback_urgent" label="Urgent"></v-switch>

                    <br clear="all" />

                    <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 w-full mb-2" :class="{'spinner': savingAiFeedback}" @click="saveAiFeedback(item)">
                        Save
                    </button>

                    <button class="rounded custom-bordered-button hover:bg-gray-200 text-xs text-gray-800 border border-gray-800 focus:outline-none py-2 px-4 w-full mb-2" :class="{'spinner': savingAiFeedback}" @click="item.ai_feedback = ''; item.ai_feedback_urgent = 0; saveAiFeedback(item)">
                        CLEAR
                    </button>

                    <button class="rounded custom-bordered-button hover:bg-gray-200 text-xs text-gray-800 border border-gray-800 focus:outline-none py-2 px-4 w-full mb-2" @click="showFeedbackBox = false">
                        CLOSE
                    </button>
                </div>

                </div>
                

            </div>
        </div>
    </div>
</template>

<script>

import { mapState } from 'vuex'
import axios from 'axios'
import moment from 'moment'

export default {
    computed: {
      ...mapState({
          // me: (state) => state.me.me,
          // profile: (state) => state.me.profile,
      }),
    },
data() {
    return {
        item: {
            ai_feedback: "",
            ai_feedback_urgent: 0
        },

        savingAiFeedback: false,

        showFeedbackBox: true,

        showTranscript: true,

        loading_bland_recording: true,

        bland_recording_data: {}
    }
},

methods: {

    displaySpeakerTimestamp(milliseconds, firstItemMilliseconds) {
          //Get hours from milliseconds
          var hours = milliseconds / (1000*60*60);

          //if (firstItemMilliseconds < 1000)
            //hours = milliseconds / (100*60*60);

          var absoluteHours = Math.floor(hours);
          var h = absoluteHours > 9 ? absoluteHours : '0' + absoluteHours;

          //Get remainder from hours and convert to minutes
          var minutes = (hours - absoluteHours) * 60;
          var absoluteMinutes = Math.floor(minutes);
          var m = absoluteMinutes > 9 ? absoluteMinutes : '0' +  absoluteMinutes;

          //Get remainder from minutes and convert to seconds
          var seconds = (minutes - absoluteMinutes) * 60;
          var absoluteSeconds = Math.floor(seconds);
          var s = absoluteSeconds > 9 ? absoluteSeconds : '0' + absoluteSeconds;

          return h + ':' + m + ':' + s;
    },

    displayTimestamp(date) {
        let timezone = this.item.timezone;

        // .tz(timezone)
        return moment.utc(date).format('ddd M/D YYYY h:mm:ss A');
    },

    async initLoad() {
        this.showFeedbackBox = true;

        this.loading_bland_recording = true;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-bland-transcript`, {
            lead_id: this.$route.query.l
        }, {
            headers: {
                'RG-Auth-Loc-Uu': this.$route.query.u
            }
        });

        this.item = {
            ai_feedback: response.data.ai_feedback,
            ai_feedback_urgent: response.data.ai_feedback_urgent,
            transcription: response.data.transcription
        };

        this.bland_recording_data.transcription = response.data.transcription;

        let original_ai_messages = JSON.parse(JSON.stringify(this.bland_recording_data.transcription));
        original_ai_messages = original_ai_messages.messages;

        console.log('original_ai_messages', original_ai_messages);

        if (1 && this.bland_recording_data.transcription.messages) {
            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-messages`, {
                lead_id: this.$route.query.l
            }, {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                }
            });

            for (var i in response.data.lsa_messages) {
                response.data.lsa_messages[i].sender = ((response.data.lsa_messages[i].participant_type == 3) ? "human" : "bot");
                response.data.lsa_messages[i].is_bland = ((response.data.lsa_messages[i].participant_type == 3) ? 0 : 1);
                response.data.lsa_messages[i].is_person = response.data.lsa_messages[i].is_bland;
                response.data.lsa_messages[i].timestamp = response.data.lsa_messages[i].event_time;
                response.data.lsa_messages[i].message = response.data.lsa_messages[i].text;

                for (var j in original_ai_messages) {
                    console.log('compare 1:', response.data.lsa_messages[i].message);
                    console.log('compare 2:', original_ai_messages[j].body);
                    if (response.data.lsa_messages[i].message == original_ai_messages[j].body) {

                        console.log("FOUD AI MESSAGE");
                        console.log(response.data.lsa_messages[i].message);
                        response.data.lsa_messages[i].is_person = 0;
                        break;
                    }
                }
            }

            if (response.data.lsa_messages.length > 0)
                this.bland_recording_data.transcription.messages = response.data.lsa_messages;
        }

        console.log('this.bland_recording_data.transcription.messages', this.bland_recording_data.transcription.messages);

        this.loading_bland_recording = false;

        setTimeout(function() {
            var objDiv = document.getElementById("ai-dialog-messages-list");
            objDiv.scrollTop = objDiv.scrollHeight;
        }, 10);
    },

    async saveAiFeedback() {
        let item = this.item;
        this.savingAiFeedback = true;
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-ai-feedback`, {
            lead_id: this.$route.query.l,
            ai_feedback: item.ai_feedback,
            ai_feedback_urgent: item.ai_feedback_urgent
        }, {
            headers: {
                'RG-Auth-Loc-Uu': this.$route.query.u
            }
        });

        this.savingAiFeedback = false;
    },
},

created() {
    let self = this
    self.initLoad();
},
}
</script>


<style scoped>

</style>